export default "__VITE_ASSET__DtxgFK8P__"